import { useContext } from "react";
import TableContext from "../../../task/TableContext";
import { useActivityView } from "./ActivityViewContext";
import { ActivityTableContextValues } from "../ActivityTableProvider";
import { ActivityListResponse } from "../entities/AcitivityListResponse";
import { ActivityPluginRegistry } from "./registry/ActivityPluginRegistry";
import { ActivityPluginProps } from "./registry/ActivityPluginTypes";
import { formatDateMonthYear } from "../../../../utils/FormatUtils";
import { restTimezone } from "../../../../utils/ParseUtils";
import { TranslationService } from "../../../../services/TranslationService";
import CompanyService from "../../../../services/CompanyService";
import Loading from "../../../shared/components/Loading";
import ErrorMessage from "../../../shared/components/Error";
import Empty from "../../../shared/components/Empty";
import Paginator from "../../../shared/Paginator";

interface ActivityListManagerProps {
  reload: (action?: (val?: unknown) => void) => void;
  reloadClientDetail: () => void;
}

export const ActivityListManager = ({
  reload,
  reloadClientDetail
}: ActivityListManagerProps) => {
  const { translate } = TranslationService;
  const { view } = useActivityView();
  const { error, response, loading } = useContext(
    TableContext
  ) as ActivityTableContextValues;

  const sortedList = [...(response?.list ?? [])].sort(
    (a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()
  );

  const groupedByMonth = sortedList.reduce(
    (prev, curr) => {
      const index = formatDateMonthYear(restTimezone(new Date(curr.date)));
      const array = prev[index] ?? [];
      array.push(curr);
      prev[index] = array;
      return prev;
    },
    {} as { [index: string]: ActivityListResponse.Item[] }
  );

  const users = CompanyService.getUsers().concat(response?.oldusers ?? []);

  if (loading) return <Loading height={512} />;
  if (error || response === undefined) {
    return (
      <ErrorMessage
        onRefresh={reload}
        message={translate.ErrorProcessingRequest}
      />
    );
  }
  if (response.list.length === 0) {
    return (
      <>
        <Empty />
        <div style={{ height: 400 }} />
      </>
    );
  }

  const renderItem = (item: ActivityListResponse.Item) => {
    const plugin = ActivityPluginRegistry.resolve(item);
    if (!plugin) return null;
    const pluginProps: ActivityPluginProps = {
      data: item,
      reload,
      users,
      reloadClientDetail
    };
    return <plugin.Component key={item.LogId} {...pluginProps} />;
  };

  return (
    <>
      {Object.keys(groupedByMonth).map((month) => (
        <div className="listResults" key={month}>
          <h5 className="h5">{month}</h5>
          {view === "compacta" ? (
            <div className="activity-feed--compact">
              {groupedByMonth[month].map(renderItem)}
            </div>
          ) : (
            groupedByMonth[month].map(renderItem)
          )}
        </div>
      ))}
      <Paginator />
    </>
  );
};
